import React, { useEffect } from "react";
import { PieChart } from "react-minimal-pie-chart";
import "./Chart.css";
//import { Globals } from "../../global/Globals";
import { useLanguage } from "../../context/Languagecontext";

const Chart = (props) => {
const { Globals } = useLanguage();

  const data = [
    { title: "Open", value: props.open ? props.open : 0, color: "#004894" }, // Dark gray
    { title: "Invited", value: props.closed ? props.closed : 0, color: "#00143C" }, // Light gray
  ];

  const openData =props.open ? props.open : '0';
  const closedData = props.closed ? props.closed : '0'

  return (
    <>
      <div className="chart">
        <div className="chart-heading">{Globals.PRODUCER.BRIEFRECEIEVED}</div>
        <div className="chart-body">
          <div className="chart-overview">
            <div className="Values">
              <div className="Value">
                {/* <div className="open-pipe"></div> */}
                <div className="open-value">{openData}</div>
              </div>
              <div className="heading">{Globals.PRODUCER.OPEN}</div>
            </div>
            <div className="Values">
              <div className="Value">
                {/* <div className="closed-pipe"></div> */}
                <div className="closed-value">{closedData}</div>
              </div>
              <div className="heading">{Globals.PRODUCER.CLOSED}</div>
            </div>
          </div>
          <PieChart
            data={data}
            lineWidth={40}
            rounded={false}
            padding={0}
            style={{ height: "138px", width: "138px" }}
          />
        </div>
      </div>
    </>
  );
};

export default Chart;
